module.exports = __webpack_public_path__ + "static/media/more.ac72f62d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/more.svg
// module id = 494
// module chunks = 0